import { Modal } from '@livecontrol/scheduler/components';
import _ from 'lodash';
import type { ReactElement } from 'react';

interface Props {
    textToShow: string;
  onConfirm: () => void;
}

export const TextModal = ({ onConfirm, textToShow }: Props): ReactElement => (
  <Modal.Prompt
    {...{
      show: true,
      title: '',
      okay: false,
      onOkay: _.partial(onConfirm, false),
      onCancel: _.partial(onConfirm, false),
      cancel: {
        variant: 'primary',
        label: 'Close'
      }
    }}
  >
    <p className='text-center'>{textToShow}</p>
  </Modal.Prompt>
);
